import React from 'react';
import { NREMTAssessmentEditor } from '../components/nremtBuilder';

const NREMTBuilder = () => {
  return <NREMTAssessmentEditor />;
};

export default NREMTBuilder;
